import { Component } from "react";

// Sends any crash straight to the native side, so it shows up in your
// existing "========== WEB MESSAGE ==========" console logs without
// needing chrome://inspect every time.
function reportToNative(payload) {
    try {
        if (window.ReactNativeWebView?.postMessage) {
            window.ReactNativeWebView.postMessage(
                JSON.stringify({ type: "JS_ERROR", ...payload })
            );
        }
    } catch (_) {
        // no-op — never let error reporting itself throw
    }
}

// Catches errors that happen outside React's render cycle
// (async callbacks, event handlers, rejected promises).
window.addEventListener("error", (event) => {
    reportToNative({
        source: "window.onerror",
        message: event.message,
        filename: event.filename,
        lineno: event.lineno,
        stack: event.error?.stack,
    });
});

window.addEventListener("unhandledrejection", (event) => {
    reportToNative({
        source: "unhandledrejection",
        message: event.reason?.message || String(event.reason),
        stack: event.reason?.stack,
    });
});

// Catches errors thrown during React's render/commit phase.
export default class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, message: "" };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, message: error?.message || "Unknown error" };
    }

    componentDidCatch(error, info) {
        reportToNative({
            source: "react-error-boundary",
            message: error?.message,
            stack: error?.stack,
            componentStack: info?.componentStack,
        });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div
                    style={{
                        minHeight: "100vh",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "24px",
                        textAlign: "center",
                        fontFamily: "sans-serif",
                        background: "#F4FAFC",
                    }}
                >
                    <p style={{ fontWeight: 700, color: "#08213D", marginBottom: 8 }}>
                        Something went wrong loading this screen.
                    </p>
                    <p style={{ fontSize: 13, color: "#5B6B7C" }}>{this.state.message}</p>
                    <button
                        type="button"
                        onClick={() => window.location.reload()}
                        style={{
                            marginTop: 16,
                            padding: "10px 20px",
                            borderRadius: 12,
                            border: "none",
                            background: "#00A4E3",
                            color: "#fff",
                            fontWeight: 700,
                        }}
                    >
                        Reload
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}